// ============================================
// 採用サイト エントリーポイント
// ============================================

// モジュールインポート
import { initCarousel } from './modules/carousel';
import { initHamburger } from './modules/hamburger';
import { initInview } from './modules/inview'; /* 変更: スクロールアニメーション追加 */
import { initTab } from './modules/tab'; /* 変更: タブ切り替え追加 */
import { initMotionPath } from './modules/motionPath'; /* 変更: パスアニメーション追加 */
import { initAccordion } from './modules/accordion'; /* 変更: アコーディオン追加 */
import { initSmoothScroll } from './modules/smoothScroll'; /* 変更: スムーススクロール追加 */

// DOM読み込み完了後に初期化
document.addEventListener('DOMContentLoaded', () => {
  initSmoothScroll();
  initCarousel();
  initHamburger();
  initInview();
  initTab();
  initMotionPath();
  initAccordion();
});
